module.exports = __webpack_public_path__ + "img/collection-engagementRingsRosegold@2x.a70dfbe.webp";